<!-- Desktop Sidebar (screen > 475px) -->
<ng-container *ngIf="screenWidth > 475">

  <div class="crm-container d-flex h-100">
    <!-- Main Sidebar -->
    <div class="main-sidebar" [ngClass]="{ 'collapsed': isCollapsed }">



      <!-- Search Bar (expanded) -->
      <div class="sidebar-search" *ngIf="!isCollapsed">
        <div class="search-input-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="search-icon">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
          <input type="text" class="search-input" placeholder="Search apps..." [(ngModel)]="sidebarSearchQuery" />
        </div>
      </div>

      <!-- Search Bar (collapsed) -->
      <div class="sidebar-search-collapsed" *ngIf="isCollapsed">
        <div class="collapsed-search-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="search-icon">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
        </div>
      </div>

      <div class="mid-layer">

        <!-- Skeleton Loader for Apps -->
        <ng-container *ngIf="isLoading">
          <div class="app-groups mt-2">
            <div class="category-label" *ngIf="!isCollapsed" style="padding-left: 12px; margin-bottom: 8px;">
              <div class="custom-skeleton" style="width: 60px; height: 12px;"></div>
            </div>
            <div *ngFor="let i of [1,2,3,4]" class="sidebar-item"
              style="pointer-events: none; padding: 8px 12px; margin-bottom: 4px; display: flex; align-items: center; gap: 12px;">
              <div class="custom-skeleton custom-skeleton-circle" style="width: 20px; height: 20px; flex-shrink: 0;">
              </div>
              <div class="tab-label w-100" *ngIf="!isCollapsed" style="display: flex; align-items: center;">
                <div class="custom-skeleton" style="width: 70%; height: 14px;"></div>
              </div>
            </div>
          </div>

          <div class="app-groups mt-3">
            <div class="category-label" *ngIf="!isCollapsed" style="padding-left: 12px; margin-bottom: 8px;">
              <div class="custom-skeleton" style="width: 80px; height: 12px;"></div>
            </div>
            <div *ngFor="let i of [1,2,3,4,5]" class="sidebar-item"
              style="pointer-events: none; padding: 8px 12px; margin-bottom: 4px; display: flex; align-items: center; gap: 12px;">
              <div class="custom-skeleton custom-skeleton-circle" style="width: 20px; height: 20px; flex-shrink: 0;">
              </div>
              <div class="tab-label w-100" *ngIf="!isCollapsed" style="display: flex; align-items: center;">
                <div class="custom-skeleton" style="width: 60%; height: 14px;"></div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading">
          <!-- Pinned Apps Group -->
          <ng-container *ngIf="(pinnedApps | sidebarSearch: sidebarSearchQuery) as filteredPinnedApps">
            <div *ngIf="filteredPinnedApps.length > 0 && hasVisibleApp(filteredPinnedApps)" class="app-groups">

              <div class="category-label" *ngIf="!isCollapsed">Pinned</div>

              <ng-container *ngFor="let item of filteredPinnedApps">
                <ng-container *ngTemplateOutlet="sideNavItem; context:{ item: item }"></ng-container>
                <ng-template #sideNavItem let-item="item">
                  <div class="sidebar-item" [class.active]="item.status"
                    *ngIf="!item.hasOwnProperty('show') || item.show" (click)="expandPanelV2(item)"
                    [matTooltip]="isCollapsed ? (item.displayName || item.appName) : ''" matTooltipPosition="right">

                    <div class="icon-wrapper" [ngClass]="{ 'active': item.status }"
                      [ngStyle]="{ '--icon-img': 'url(' + logo[item.appName] + ')' }">
                    </div>

                    <!-- Label -->
                    <span class="tab-label" *ngIf="!isCollapsed">
                      {{ item.displayName || item.appName }}
                    </span>

                    <!-- Count badge -->
                    <span class="nav-badge" *ngIf="!isCollapsed && item.count > 0">{{ item.count }}</span>

                    <!-- Pin icon -->
                    <div *ngIf="!isCollapsed" class="pin-icon" (click)="markAppPinned(item); $event.stopPropagation()"
                      [matTooltip]="item.favorite ? 'Unpin' : 'Pin'" matTooltipPosition="right">
                      <svg *ngIf="!item.favorite" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="pin-svg">
                        <path d="M12 17v5" />
                        <path
                          d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                      </svg>
                      <svg *ngIf="item.favorite" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="pin-svg pinned">
                        <path d="M12 17v5" />
                        <path
                          d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                      </svg>
                    </div>

                  </div>
                </ng-template>
              </ng-container>

            </div>
          </ng-container>

          <!-- Grouped sections -->
          <ng-container *ngFor="let group of groupedSideNav">
            <ng-container *ngIf="(group.apps | sidebarSearch: sidebarSearchQuery) as filteredApps">
              <div class="app-groups" *ngIf="filteredApps.length > 0 && hasVisibleApp(filteredApps)">

                <div class="category-label" *ngIf="!isCollapsed">{{ group.category }}</div>

                <ng-container *ngFor="let item of filteredApps">
                  <ng-container *ngTemplateOutlet="groupNavItem; context:{ item: item }"></ng-container>
                </ng-container>

                <ng-template #groupNavItem let-item="item">
                  <div class="sidebar-item" [class.active]="item.status"
                    *ngIf="!item.hasOwnProperty('show') || item.show" (click)="expandPanelV2(item)"
                    [matTooltip]="isCollapsed ? (item.displayName || item.appName) : ''" matTooltipPosition="right">

                    <div class="icon-wrapper" [ngClass]="{ 'active': item.status }"
                      [ngStyle]="{ '--icon-img': 'url(' + logo[item.appName] + ')' }">
                    </div>

                    <!-- Label -->
                    <span class="tab-label" *ngIf="!isCollapsed">
                      {{ item.displayName || item.appName }}
                    </span>

                    <!-- Count badge -->
                    <span class="nav-badge" *ngIf="!isCollapsed && item.count > 0">{{ item.count }}</span>

                    <!-- Pin icon (hide for Home/Dashboard) -->
                    <div *ngIf="!isCollapsed && (item.displayName || item.appName)?.toLowerCase() !== 'home'"
                      class="pin-icon" (click)="markAppPinned(item); $event.stopPropagation()"
                      [matTooltip]="item.favorite ? 'Unpin' : 'Pin'" matTooltipPosition="right">
                      <svg *ngIf="!item.favorite" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="pin-svg">
                        <path d="M12 17v5" />
                        <path
                          d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                      </svg>
                      <svg *ngIf="item.favorite" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="pin-svg pinned">
                        <path d="M12 17v5" />
                        <path
                          d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                      </svg>
                    </div>

                  </div>
                </ng-template>

              </div>
            </ng-container>
          </ng-container>
        </ng-container>

      </div><!-- /mid-layer -->

      <!-- Footer -->
      <div class="footer-layer">
        <!-- Create Business -->
        <!-- <div class="add-apps-btn" *ngIf="!isCollapsed" (click)="navigateToBusinessCreation()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="add-icon">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
          <span>Create business</span>
        </div>
        <div class="add-apps-btn add-apps-collapsed" *ngIf="isCollapsed" matTooltip="Create business"
          matTooltipPosition="right" (click)="navigateToBusinessCreation()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="add-icon">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </div> -->
        <!-- Add Apps -->
        <div class="add-apps-btn" *ngIf="!isCollapsed && (isStaffAdmin || hasAppPermission)" (click)="goToAddApps()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="add-icon">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
          <span>Add apps</span>
        </div>
        <div class="add-apps-btn add-apps-collapsed" *ngIf="isCollapsed && (isStaffAdmin || hasAppPermission)" matTooltip="Add apps"
          matTooltipPosition="right" (click)="goToAddApps()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="add-icon">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </div>

        <!-- Collapse -->
        <div class="collapse-btn-row" (click)="toggleSidebar()" *ngIf="!isCollapsed">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="collapse-icon">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
            <path d="M9 3v18" />
            <path d="m16 15-3-3 3-3" />
          </svg>
          <span class="collapse-label">Collapse</span>
        </div>

        <div class="add-apps-collapsed collapse-btn-row" *ngIf="isCollapsed" (click)="toggleSidebar()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="collapse-icon"
            matTooltip="Expand" matTooltipPosition="right">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
            <path d="M9 3v18"></path>
            <path d="m14 9 3 3-3 3"></path>
          </svg>
        </div>

      </div>

    </div><!-- /main-sidebar -->


    <!-- Sub Panel -->
    <div class="sub-panel" [ngClass]="{'sub-collapsed': isSubPanelCollapsed}"
      *ngIf="activeSubApp?.subAppName?.length > 0 && activeSubApp.appName != 'Planboard' && activeSubApp.appName != 'PassBook' && activeSubApp.appName.split(' ').join('_') != 'Refer_and_Earn'">
      <div class="sub-panel-header">
        <div class="app-header-icon" [ngStyle]="{ '--icon-img': 'url(' + logo[activeSubApp.appName] + ')' }"
          [matTooltip]="isSubPanelCollapsed ? (activeSubApp.displayName || activeSubApp.appName) : ''"
          matTooltipPosition="right"></div>
        <div class="header-breadcrumb" *ngIf="!isSubPanelCollapsed">
          <span class="app-name-text">{{ (activeSubApp.displayName || activeSubApp.appName) | titlecase }}</span>
          <ng-container *ngFor="let sub of activeSubApp.subAppName">
            <ng-container *ngIf="sub.status">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="breadcrumb-chevron">
                <path d="m9 18 6-6-6-6" />
              </svg>
              <span class="sub-name-text">{{ (sub.displayName || sub.subAppName) | titlecase }}</span>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="sub-panel-list">
        <ng-container *ngFor="let sub of activeSubApp.subAppName">
          <div *ngIf="!sub.hasOwnProperty('show') || sub.show" class="sub-panel-item"
            [ngClass]="{ 'active-sub': sub.status }" (click)="changeSubPanel(activeSubApp, sub)"
            [matTooltip]="isSubPanelCollapsed ? (sub.displayName || sub.subAppName) : ''" matTooltipPosition="right">

            <div class="sub-item-icon" [ngClass]="{ active: sub.status }"
              [ngStyle]="{ '--icon-img': 'url(' + logo[sub.subAppName] + ')' }">
            </div>

            <div class="name-text" *ngIf="!isSubPanelCollapsed">
              {{ (sub.displayName || sub.subAppName) | titlecase }}
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Collapse Section -->
      <div class="sub-panel-collapse" (click)="toggleSubPanel()">
        <svg *ngIf="!isSubPanelCollapsed" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="collapse-panel-icon">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
          <path d="M9 3v18" />
          <path d="m16 15-3-3 3-3" />
        </svg>
        <span class="collapse-text" *ngIf="!isSubPanelCollapsed">Collapse</span>

        <svg *ngIf="isSubPanelCollapsed" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="collapse-panel-icon" matTooltip="Expand" matTooltipPosition="right">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
          <path d="M9 3v18" />
          <path d="m14 9 3 3-3 3" />
        </svg>
      </div>
    </div>

  </div>

</ng-container>

<!-- Business Info template (used in mobile) -->
<ng-template #BusinessInfo>
  <div class="top_layer">
    <div class="business_name dropdown">
      <div class="profile dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown"
        aria-expanded="false">
        <div class="tag_name">
          <div class="business_tag" *ngIf="!bDetails?.logo">
            {{businessName.split('')[0] | uppercase}}
          </div>
          <img [src]="bDetails?.logo" alt="" *ngIf="bDetails?.logo" class="logo-img">
          <div class="left_bar" (click)="goToListing()">
            <div class="left_bar_sub">
              <div class="business_title">
                {{businessName | limitToPipe : 9 | titlecase}}{{businessName.length > 9 ? '' : ''}}
              </div>
            </div>
            <div class="business_type">
              {{bDetails?.subIndustryName | limitToPipe : 18}}{{bDetails?.subIndustryName > 18 ? '...' : ''}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Mobile view -->
<ng-container *ngIf="screenWidth < 475">
  <div class="mobile_screen">
    <ng-container *ngTemplateOutlet="BusinessInfo"></ng-container>
    <div class="top_section">
      <div *ngFor="let item of sideNavData; index as i">
        <div class="mobile_tab" (click)="expandPanel(item)">
          <div class="img_name">
            <div class="img_url">
              <img src="./../../../../assets/images/sidepanel/{{((item.name).split(' ').join('_')).toLowerCase()}}.svg"
                alt="icon" *ngIf="!item.status">
              <img
                src="./../../../../assets/images/sidepanel/{{((item.name).split(' ').join('_')).toLowerCase()}}_active.svg"
                alt="icon" *ngIf="item.status">
            </div>
            <div [ngClass]="item.status ? 'tab_name_active' : 'tab_name'">
              {{item.name}}
            </div>
          </div>
          <div class="arrow" *ngIf="item.subArray.length > 0">
            <mat-icon *ngIf="!item.status">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="item.status">keyboard_arrow_up</mat-icon>
          </div>
        </div>
        <div class="second-panel" *ngIf="item.subArray.length > 0 && item.status">
          <ng-container *ngFor="let subPanel of item.subArray">
            <div class="second_panel_data"
              [ngClass]="subPanel.status ? 'second_panel_data_active' : 'second_panel_data'"
              (click)="subDataClick(item.name,subPanel)">
              <img src="./../../../../assets/images/sidepanel/dot.svg" alt="dot" class="dot_icon"
                *ngIf="subPanel.status">
              <div class="name">
                {{subPanel.name}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="last_layer">
      <div class="lite_hr_line"></div>
      <div class="bottom_single_tab_1" (click)="businessDetails()">
        <div class="img_name">
          <div class="sub_img_url">
            <img src="./../../../../assets/images/sidepanel/account.svg" alt="accounts image">
          </div>
          <div class="name_icon">
            <div class="tab_name">
              Business
            </div>
            <div class="sub_text">
              Manage Business
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #BusinessListPopup>
  <div class="show_list_business">
    <ul class="dropdown-menu">
      <div class="title_manage">
        <div class="popup_title">Your Businesses</div>
        <div class="closing_bar" id="closeBottomSheet" data-bs-dismiss="offcanvas" data-bs-target="#addPageBottomSheet"
          aria-label="Close"><mat-icon>close</mat-icon></div>
      </div>

      <div class="list_business">
        <ng-container *ngFor="let item of allBusiness">
          <div class="heading_section" (click)="switchBusiness(item)" style="cursor: pointer">
            <div class="heading" [style.color]="item.status ? '#0496FF' : ''">
              {{item.name}}
            </div>
            <div class="done_btn">
              <button class="home-icon"><mat-icon
                  [style.color]="item.status ? '#0496FF' : ''">keyboard_arrow_right</mat-icon></button>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="create_btn">
        <button class="manage-business" (click)="businessDetails()"><img
            src="../../../../assets/images/sidepanel/manage_business.svg" alt="">Manage</button>
        <button class="create-business" (click)="createNewBusiness()">Create New</button>
      </div>
    </ul>
  </div>
</ng-template>

<ng-template #loadingSkeleton>
  <div *ngFor="let i of [1,1,1]">
    <div class="d-flex align-items-center gap-3">
      <ngx-skeleton-loader count="1" appearance="circle"
        style="width: 40px; height: 40px; margin-bottom: 10px;"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" style="width: 150px; height: 15px;"></ngx-skeleton-loader>
    </div>
    <div class="skelton-main">
      <ngx-skeleton-loader count="1"
        style="width: 100px; height: 15px; margin-left:23%; margin-bottom: 10px;"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1"
        style="width: 100px; height: 15px; margin-left:23%; margin-bottom: 10px;"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1"
        style="width: 100px; height: 15px; margin-left:23%; margin-bottom: 10px;"></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>